"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipPopper = void 0;
const styles_1 = require("@mui/material/styles");
exports.TooltipPopper = (0, styles_1.styled)("div")(({ theme }) => ({
    color: theme.colours.white,
    marginRight: "8px",
    backgroundColor: theme.colours.slate,
    borderRadius: "4px",
    padding: "5px 10px",
    maxWidth: "300px",
    fontSize: "12px",
    lineHeight: "17px",
    fontWeight: 500
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Rvb2x0aXAvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLGlEQUE4QztBQUVqQyxRQUFBLGFBQWEsR0FBRyxJQUFBLGVBQU0sRUFBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDekQsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztJQUMxQixXQUFXLEVBQUUsS0FBSztJQUNsQixlQUFlLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO0lBQ3BDLFlBQVksRUFBRSxLQUFLO0lBQ25CLE9BQU8sRUFBRSxVQUFVO0lBQ25CLFFBQVEsRUFBRSxPQUFPO0lBQ2pCLFFBQVEsRUFBRSxNQUFNO0lBQ2hCLFVBQVUsRUFBRSxNQUFNO0lBQ2xCLFVBQVUsRUFBRSxHQUFHO0NBQ2hCLENBQUMsQ0FBQyxDQUFDIn0=